import { gql } from '@efficiently/client-core-graphql-models';

export const UPDATE_CONTENT = gql(`
	mutation UpdateContent($args: ContentUpdateArgs!) {
		updateContent(args: $args) {
			...ContentDomainContentFields
		}
	}
`);
